import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './marketing.css';

/** The wordmark, with "to" set lowercase in purple — the one recurring flourish. */
export function Wordmark() {
  return (
    <Link to="/" className="v2v-wordmark" aria-label="Voice to Value home">
      Voice<span className="to">to</span>Value
    </Link>
  );
}

function Header() {
  return (
    <header className="v2v-header">
      <div className="shell">
        <Wordmark />
        <nav className="v2v-nav">
          <Link to="/privacy" className="nav-link-privacy">
            Confidentiality
          </Link>
          <Link className="btn btn-outline" to="/contact">
            Contact me
          </Link>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <>
      {/* Split call-to-action, echoing the wireframe's two-column footer. */}
      <section className="v2v-split" aria-label="Next steps">
        <Link className="split-lilac" to="/contact">
          <span>Contact me</span>
          <span className="arrow" aria-hidden="true">
            ›
          </span>
        </Link>
        <Link className="split-white" to="/privacy">
          <span>Our commitment to confidentiality</span>
          <span className="arrow" aria-hidden="true">
            ›
          </span>
        </Link>
      </section>

      <footer className="v2v-footer">
        <div className="shell">
          <div className="foot-brand">
            <Wordmark />
            <p className="foot-tag">Your people have the answers. We&rsquo;ll help you hear them.</p>
          </div>
          <nav aria-label="Footer">
            <Link to="/privacy">Confidentiality</Link>
          </nav>
          <p className="copyright">
            © {new Date().getFullYear()} Voice to Value | Employee engagement surveys
          </p>
        </div>
      </footer>
    </>
  );
}

/** Wraps a marketing page in the shared header/footer and the `.v2v` style scope. */
export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <main className="v2v v2v-main">
      <Header />
      {children}
      <Footer />
    </main>
  );
}
